import menu from "magicbean-saas-common/src/core/language/zh/menu.json";
import common from "./common.json";
import user from "./user.json";
import permissions from "./permissions.json";
import generalInformation from "./generalInformation.json";

export default {
  menu,
  common,
  user,
  permissions,
  generalInformation,
};
